import { Value } from './value.interface';

export enum FilterInputTypes {
  _dropdown = 'dropdown',
  _cascadeSelect = 'cascadeSelect',
  _multiSelect = 'multiSelect',
  _text = 'text',
  _number = 'number',
  _checkbox = 'checkbox',
  _datePiker = 'datePiker',
  _time = 'time',
  _timeRange = 'timeRange',
  _timeRangeFrom = 'timeRangeFrom',
  _timeRangeTo = 'timeRangeTo',
  _date = 'date',
  _dateRange = 'dateRange',
  _dateRangeFrom = 'dateRangeFrom',
  _dateRangeTo = 'dateRangeTo',
}

export interface IFilterInput {
  label?: string;
  resultLabel: string;
  type: FilterInputTypes;
  required?: boolean;
  placeholder?: string;
  controlName: string;
  options?: Value[] | any[];
  optionLabel?: string;
  disabled?: boolean;
  rangeFilterReferences?: IFilterInput[];
  onChange?: (value: any) => void;
  enableFilters?: boolean;
  defaultValue?: any;
  minDate?: Date;
  maxDate?: Date;
  clearable?: boolean;
  hasVirtualScroll?: boolean;
  hasGroup?: boolean;

  permissionKey?: string;
  visible?: boolean;
}

export type ActionsPlacement = 'start' | 'end';
